// @flow
import styled, {css} from "styled-components";
import {topHeaderBarHeight} from "./TopBar/TopBarStyle";
import {styles} from "../config";

export const selectionButtonDistanceFromSide = 13.5;

export const Full = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const UnderTopBarFloater = css`
    position: fixed;
    top: ${topHeaderBarHeight};
    z-index: 5;
    background-color: #ffffff;
    text-align: center;
    vertical-align: middle; 
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    left: 16px;
    right: 16px;
`;

export const floatingContainerDistanceFromSides = `16px`;

export const FloatingContainer = css`
    box-shadow: 0px 3px 8px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    width: calc(100% - (2 * ${floatingContainerDistanceFromSides}));
    left: ${floatingContainerDistanceFromSides};
    right: ${floatingContainerDistanceFromSides};
    overflow: hidden;
    z-index: 1;
`;


export const SelectionButton = styled.div`
    width: ${100 - (selectionButtonDistanceFromSide * 2)}%;
    min-width: ${100 - (selectionButtonDistanceFromSide * 2)}%;
    left: ${selectionButtonDistanceFromSide}%;
    right: ${selectionButtonDistanceFromSide}%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    box-shadow: ${props => props.active ? "0 1px 4px 0 #0000003f inset" : "0 1px 3px 0 #00000033"};
    color: ${props => props.active ? "white" : "inherit"};
    background-color: ${props => props.active ? styles.primaryColor : "inherit"};
    margin-bottom: 10px;
    border-radius: 5px;
`;

export const ThankYouFloaterDisclaimer = styled.label`
    margin-top: 3px;
    font-size: 14px;
    line-height: 17px;
    font-weight: 300;
    color: #9b9b9b;
`;

export const ThankYouFloater = css`
    min-height: 130px;
    max-width: 90%;
    right: 5%;
    left: 5%;
    overflow: hidden;
    font-weight: 300;
    padding: 3%;
`;

export const ThankYouFloaterTitle = styled.label`
    color: ${styles.primaryColor};
    font-weight: 500;
    font-size: 21px;
    min-width: 50%;
`;

export const ThankYouFloaterContent = styled.div`
    margin-top: 3px;
    font-size: 15px;
    line-height: 17px;
    min-width: 50%;
`;

export const VerticalDelimeter = css`
    margin-right: 5px;
    margin-left: 5px;
`;



// WEBPACK FOOTER //
// ./src/Components/AppStyle.js